<template>
  <el-dialog
      title="新增过磅确认记录"
      :close-on-click-modal="false"
      :visible.sync="visible"
      width="680px"
      @close="onClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-alert title="请先在SAP完成过磅！" type="error" :closable="false"/>
      <el-form-item label="所属基地">
        {{ baseInfo.com_name }}
      </el-form-item>
      <el-form-item label="门岗" prop="door_name">
        <el-input
            class="w-96"
            placeholder="请输入门岗"
            v-model="form.door_name"
        ></el-input>
      </el-form-item>
      <el-form-item label="地磅称台号" prop="weighbridge_code">
        <el-input
            class="w-96"
            placeholder="请输入地磅称台号"
            v-model="form.weighbridge_code"
        ></el-input>
        <el-tooltip
            placement="right-start"
            :value="showTooltip"
            :manual="true"
            :hide-after="0"
        >
          <div slot="content">
            <div v-for="item in WeighbridgeCodes" :key="item.id" class="my-1">{{ item.name }}-》{{
                item.weighbridge_code
              }}
            </div>
          </div>
          <i class="el-icon-info text-lg ml-2 text-gray-500"/>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="过磅类型" prop="weight_type">
        <el-radio-group class="w-96" v-model="form.weight_type">
          <el-radio :label="1">过磅进厂</el-radio>
          <el-radio :label="2">过磅出厂</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="预约号" prop="booking_code">
        <el-input
            class="w-96"
            placeholder="请输入明确的预约号"
            clearable
            :maxlength="15"
            v-model.trim="form.booking_code"
            @blur="fetchBookingByCode"
            @keyup.enter.native="fetchBookingByCode"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号" prop="order_code">
        <el-input
            class="w-96"
            placeholder="请输入订单号"
            v-model="form.order_code"
        >">
        </el-input
        >
      </el-form-item>
      <el-form-item label="车牌号" prop="license_plate">
        <el-input
            class="w-96"
            placeholder="请输入车牌号"
            v-model="form.license_plate"
        >">
        </el-input
        >
      </el-form-item>
      <el-form-item label="重量（吨）" prop="weight">
        <!-- <el-input class="w-96" placeholder="请输入重量" v-model="form.weight"
          >"></el-input
        > -->
        <el-input-number placeholder="请输入重量" class="inputNumber w-96" v-model="form.weight"
                         controls-position="right" :min="0"
                         :controls="false"></el-input-number>
      </el-form-item>
      <el-form-item label="过磅时间" prop="weighing_time">
        <el-date-picker
            class="!w-96"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form.weighing_time"
            type="datetime"
            placeholder="请选择过磅时间"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfirm"
      >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";
import {debounce} from "lodash";

export default {
  data() {
    return {
      visible: false,
      showTooltip: false,
      WeighbridgeCodes: [],
      form: {},
      rules: {
        door_name: [{required: true, message: "请输入门岗", trigger: "blur"}],
        weighbridge_code: [
          {required: true, message: "请输入地磅称台号", trigger: "blur"}
        ],
        weight_type: [
          {required: true, message: "请选择过磅类型", trigger: "change"}
        ],
        booking_code: [
          {required: true, message: "请输入预约号", trigger: "blur"}
        ],
        order_code: [
          {required: true, message: "请输入订单号", trigger: "blur"}
        ],
        license_plate: [
          {required: true, message: "请输入车牌号", trigger: "blur"},
          {message: "车牌号格式错误", trigger: "blur", pattern: /^.{7,8}$/}
        ],
        weight: [{required: true, message: "请输入重量", trigger: "blur"}],
        weighing_time: [
          {required: true, message: "请选择过磅时间", trigger: "change"}
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  watch: {
    visible(v) {
      if (v) {
        setTimeout(() => {
          this.showTooltip = true;
        }, 300);
      } else {
        this.showTooltip = false;
      }
    }
  },
  created() {
    this.getWeighbridgeCodes();
  },
  methods: {
    async getWeighbridgeCodes() {
      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/query_c3"
        });
        this.WeighbridgeCodes = res.data.data;
      } catch (error) {
      }
    },
    onOpen(weight_type) {
      this.$set(this.form, "weight_type", weight_type);
      this.$set(
          this.form,
          "weighing_time",
          moment().format("YYYY-MM-DD HH:mm:ss")
      );
      this.visible = true;
      this.getLastPound();
    },
    onClose() {
      this.form = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.onSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit: debounce(async function () {
      const params = {
        ...this.form,
        com_id: this.baseInfo.com_id
      };
      try {
        await this.$common.http({
          url: "/api/queue/admin/add_pound",
          data: params
        });
        this.$common.pcToastSuccess("添加成功");
        this.visible = false;
        this.$emit("ok");
      } catch (error) {
      }
    }, 300),
    async getLastPound() {
      const res = await this.$common.http({
        url: "/api/queue/admin/last_pound",
        data: {}
      });
      const {door_name} = res.data.data;
      this.$set(this.form, "door_name", door_name);
    },
    async fetchBookingByCode() {
      const keyword = (this.form.booking_code || "").trim();
      if (!keyword) {
        this.clearBookingAutoFields();
        return;
      }

      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/query_booking_record1",
          data: {
            page: 1,
            page_size: 1,
            booking_code: keyword
          },
          noLoading: true
        });
        const rows = (((res || {}).data || {}).data || {}).data || [];
        const booking = rows.find(item => item.code === keyword);
        if (!booking) {
          this.clearBookingAutoFields();
          this.$common.pcError("未找到对应预约记录");
          return;
        }
        this.handleBookingCodeResolved(booking);
      } catch (error) {
        console.log(error);
        this.clearBookingAutoFields();
      }
    },
    clearBookingAutoFields() {
      this.$set(this.form, "order_code", "");
      this.$set(this.form, "license_plate", "");
    },
    handleBookingCodeResolved(item) {
      const {order_code, license_plate} = item;
      this.$set(this.form, "order_code", order_code);
      this.$set(this.form, "license_plate", license_plate);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px 0px !important;
}

.inputNumber {
  /deep/ .el-input__inner {
    text-align: left !important;
  }
}

/deep/ .el-input__validateIcon {
  display: none;
}
</style>
